import React, {  ReactNode } from "react";
import { createGenericModalContext } from "../../../../../components/BasicComponents/GenericModalContext";
import DialogDetalheHistoricoRecebimento from "./DialogDetalheHistoricoRecebimento";

const { GenericModalProvider, useGenericModal } = createGenericModalContext<string>();

export const ModalDetalheHistoricoRecebimentoProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
   return (
           <GenericModalProvider
               ModalComponent={DialogDetalheHistoricoRecebimento}
               urlParam="detalhe-historico-recebimento"
           >
               {children}
           </GenericModalProvider>
       );
};

export const useModalDetalheHistoricoRecebimento = useGenericModal;